import { DEFAULT_LAYOUT } from '@/router/base';

export default {
  path: '/multilevel_menu_example',
  name: '/multilevel_menu_example',
  component: DEFAULT_LAYOUT,
  meta: {
    title: '多级导航',
    icon: 'SfTextLeftJustified',
    order: 10,
  },
  children: [
    {
      path: 'page1',
      name: '/multilevel_menu_example/page1',
      component: () => import(/* webpackChunkName:'home' */ '@/pages/multilevel_menu_example/page1.vue'),
      meta: {
        title: '导航1', // 页面tab显示的名称
      },
    },
    {
      path: 'page2',
      meta: {
        title: '导航2', // 页面tab显示的名称
      },
      children: [
        {
          path: 'page2-1',
          name: '/multilevel_menu_example/page2/page2-1',
          component: () => import(/* webpackChunkName:'home' */ '@/pages/multilevel_menu_example/page2/page2-1.vue'),
          meta: {
            title: '导航2-1', // 页面tab显示的名称
          },
        },
        {
          path: 'page2-2',
          name: '/multilevel_menu_example/page2/page2-2',
          component: () => import(/* webpackChunkName:'home' */ '@/pages/multilevel_menu_example/page2/page2-2.vue'),
          meta: {
            title: '导航2-2', // 页面tab显示的名称
          },
        },
        {
          path: 'page2-3',
          name: '/multilevel_menu_example/page2/page2-3',
          meta: {
            title: '导航2-3', // 页面tab显示的名称
          },
          children: [
            {
              path: 'page2-3-1',
              name: '/multilevel_menu_example/page2/page2-3/page2-3-1',
              component: () =>
                import(/* webpackChunkName:'home' */ '@/pages/multilevel_menu_example/page2/page2-3/page2-3-1.vue'),
              meta: {
                title: '导航2-3-1',
              },
            },
            {
              path: 'page2-3-2',
              name: '/multilevel_menu_example/page2/page2-3/page2-3-2',
              component: () =>
                import(/* webpackChunkName:'home' */ '@/pages/multilevel_menu_example/page2/page2-3/page2-3-2.vue'),
              meta: {
                title: '导航2-3-2',
              },
            },
          ],
        },
      ],
    },
  ],
};
